import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TooltipConfig, TooltipModule } from 'ngx-bootstrap';
import {
  AlmEditableModule,
  AlmIconModule,
  MarkdownModule,
  WidgetsModule
} from 'ngx-widgets';
import { LabelsModule } from '../labels/labels.module';
import { F8TimePipeModule } from './../../pipes/f8-time.module';
import { UserAvatarModule } from './../../widgets/user-avatar/user-avatar.module';
import { WorkItemEventComponent } from './work-item-event.component';



export class WorkItemEventModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        AlmEditableModule,
        AlmIconModule,
        WidgetsModule,
        LabelsModule,
        MarkdownModule,
        CommonModule,
        TooltipModule,
        F8TimePipeModule,
        UserAvatarModule
    ],
    declarations: [WorkItemEventComponent],
    exports: [WorkItemEventComponent],
    providers: [TooltipConfig]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
